var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{staticClass:"block",attrs:{"color":"danger","type":"filled","icon-pack":"feather","icon":"icon-trash"},on:{"click":function($event){$event.stopPropagation();return _vm.params.colDef.CellRendererParams.deletePayslip(_vm.params.data.id, _vm.params.rowIndex)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }